import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import '@mui/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
// @ts-ignore
import { FacebookProvider } from 'react-facebook';
import { Provider } from 'react-redux';
import { Outlet } from 'react-router-dom';
import {
  PageMeta,
  StartUp,
  StyledSnackbarProvider,
  ExpiredSessionModal,
} from 'components';
import { secretManager } from 'services/api/config';
import AudioProvider from 'services/contexts/WavesurferContext/WavesurferProvider';
import { FunnelProvider } from 'services/contexts/FunnelContext';
import './i18n';
import ChatBot from 'components/ChatBot';
import store from './services/store';
import theme from './theme';

function App() {
  return (
    <>
      <PageMeta />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Provider store={store}>
            <ExpiredSessionModal />
            <GoogleOAuthProvider clientId={secretManager.googleClientId}>
              <FacebookProvider
                version="v10.0"
                appId={secretManager.facebookClientId}
              >
                <StartUp>
                  <AudioProvider>
                    <StyledSnackbarProvider>
                      {/* @ts-ignore */}
                      <FunnelProvider>
                        <Outlet />
                      </FunnelProvider>
                    </StyledSnackbarProvider>
                  </AudioProvider>
                </StartUp>
              </FacebookProvider>
            </GoogleOAuthProvider>
            <ChatBot />
          </Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}

export default App;
